<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindowSA">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MR"][obj_memberRanking.I > 0? "ELP": "ALP"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>1</span>{{this.getLanguage["MR"]["PS"]}}</h6>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol md="4">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["GN"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="false"
                                                              :options="dd_agentgroup"
                                                              :defaultExpandLevel="Infinity"
                                                              valueConsistsOf="LEAF_PRIORITY"
                                                              :disable-branch-nodes="false"
                                                              :clearable="false"
                                                              :flat="true"
                                                              :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                              :limit="1"
                                                              :limitText="count => `+${count}`"
                                                              v-model="obj_memberRanking.AGIT"
                                                              @input="AgentGroupChange"
                                                              :disabled="obj_memberRanking.I > 0 "/>
                                            <span class="ErrMsg">{{ ValidationErrMsg('AGIT','AG') }}</span>
                                        </CCol>

                                        <CCol md="4">
                                            <label class="col-form-label-sm">{{this.getLanguage["MR"]["LPN"]}}<span class="required" /> :</label>
                                            <CInput :placeholder="this.getLanguage['MR']['LPN']"
                                                    size="sm"
                                                    :value="obj_memberRanking.MRN"
                                                    @change="v => obj_memberRanking.MRN = v"
                                                    ref="PC"></CInput>
                                            <span class="ErrMsg">{{ ValidationErrMsg('MRN','LPN') }}</span>
                                        </CCol>
                                        <CCol md="4">
                                            <label class="col-form-label-sm">{{this.getLanguage["MR"]["PET"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :clearable="false"
                                                        :options="dd_MRPointCalculationType"
                                                        :placeholder="getLanguage['MR']['PET']"
                                                        :max-height="200"
                                                        v-model="obj_memberRanking.PCT"
                                                        :disabled="obj_memberRanking.I > 0 && ValidateStartDate(dateTS.startDate , minDate)"
                                                        ref="PET" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('PCT','PET') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <!-- <CCol md="4">
                                            <label class="col-form-label-sm">{{this.getLanguage["MR"]["MOV"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :clearable="false"
                                                        :options="dd_Validitye"
                                                        :placeholder="getLanguage['MR']['MOV']"
                                                        :max-height="200"
                                                        v-model="obj_memberRanking.MOV"
                                                        :disabled="obj_memberRanking.I > 0"
                                                        ref="VLTY" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('MOV','MOV') }}</span>
                                        </CCol> -->

                                        <CCol md="4">
                                            <label class="col-form-label-sm">{{this.getLanguage["MR"]["PD"]}} <span class="required" /> :</label>
                                            <span v-if="obj_memberRanking.I > 0 && ValidateStartDate(dateTS.startDate , minDate)">
                                                <CInput type="text" disabled size="sm" vertical :placeholder="this.getLanguage['GL']['SD']" :value="dateTS.startDate | moment('DD MMM YYYY HH:mm:ss')"></CInput>
                                            </span>
                                            <span v-else>
                                                <date-range-picker :autoApply="true"
                                                                   opens="right"
                                                                   :show-dropdowns="true"
                                                                   v-model="dateTS"
                                                                   @update="MemberRankingDateRangePickerUpdateEvent"
                                                                   :ranges="false"
                                                                   :single-date-picker="true"
                                                                   class="pcDaterange"
                                                                   :minDate="minDate">
                                                    <div slot="input" slot-scope="picker">
                                                        <div v-if="dateTS.startDate != ''">
                                                            <CInput size="sm"
                                                                    :value="dateTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                                    @change="DateTimeChange('RD',$event)"
                                                                    style="background: #f9f9f9" />
                                                        </div>
                                                        <div v-else>
                                                            <CInput size="sm"
                                                                    @change="DateTimeChange('RD',$event)"
                                                                    style="background: #f9f9f9" />
                                                        </div>
                                                    </div>
                                                </date-range-picker>
                                            </span>
                                        </CCol>
                                        <CCol md="4">
                                            <div class="mt-4">
                                                <label class="col-form-label-sm" style="margin-right: 20px;">{{this.getLanguage["AFF"]["ACT"]}} ?</label>
                                                <label class="switch">
                                                    <input type="checkbox" true-value="2" false-value="1" v-model="obj_memberRanking.RS" />
                                                    <span class="slider round"></span>
                                                </label>
                                            </div>
                                        </CCol>
                                    </CRow>

                                    <CRow class="mt-3" v-if="this.dd_language.length > 0">
                                        <CCol>
                                            <CCard>
                                                <CCardHeader @click="visible = !visible" style="cursor:pointer">
                                                    <Strong>{{this.getLanguage["MR"]["LPLS"]}}</Strong>
                                                    <div class="fa-pull-right">
                                                        <span v-if="visible">{{this.getLanguage["BTN"]["HD"]}}</span>
                                                        <span v-else>{{this.getLanguage["BTN"]["V"]}}</span>
                                                    </div>
                                                </CCardHeader>
                                                <CCardBody v-show="visible">
                                                    <div class="row mx-0" id="webTempSetting">
                                                        <div class="col-md-2 px-0">
                                                            <div class="nav flex-column nav-pills tempScrollbar" aria-orientation="vertical" style="max-height: 584px; overflow: hidden scroll; padding: 0; flex-wrap: nowrap ">
                                                                <a class="" :class="(selectedLang == item.language)? 'nav-link active' : 'nav-link'" @click="selectedLang = item.language" v-for="(item, index) in obj_memberRanking.tncModels" :key="index" style="border-radius: 0px; padding: 0.5rem 0.5rem; font-size: smaller;">
                                                                    <div class="d-flex align-items-center">
                                                                        <span class="flagClass mr-2" :class="mapLanguageFlag(item.language)"></span>
                                                                        <span>{{ item.label }}</span>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-10 pr-0">
                                                            <div class="tab-content">
                                                                <div class="card tab-content p-2">
                                                                    <div :class="item.language == selectedLang ? 'tab-pane fade active show': 'tab-pane fade'" :id="'lang-'+item.language" v-for="(item, index) in obj_memberRanking.tncModels">
                                                                        <CCol col="12">
                                                                            <label class="col-form-label-sm font-weight-bold">{{ item.label }}</label>
                                                                        </CCol>
                                                                        <CCol col="4">
                                                                            <label class="col-form-label-sm">{{getLanguage["MR"]["LPN"]}}:</label>
                                                                            <CInput :placeholder="getLanguage['MR']['MRN']" size="sm" v-model="obj_memberRanking.tncModels[index].program_name" ref="TN"></CInput>
                                                                        </CCol>
                                                                        <CCol col="12">
                                                                            <label class="col-form-label-sm">{{getLanguage['MR']['TNC']}}:</label>
                                                                            <editor :id="'htmluuid-'+index" @onChange="HTMLEditorTextChange($event,index)" :value="obj_memberRanking.tncModels[index].tnc_content" :init="init" />
                                                                        </CCol>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </CCardBody>
                                            </CCard>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>2</span>{{this.getLanguage["MR"]["TS"]}}</h6>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol md="3">
                                            <label class="col-form-label-sm full-width">
                                                {{this.getLanguage['MR']['BL']}}:
                                            </label>
                                            <treeselect :multiple="false"
                                                        :options="dd_bl"
                                                        :placeholder="this.utilGetDDLanguage('MR.SBL')"
                                                        v-model="obj_memberRanking.BSET"
                                                        :clearable="false"
                                                        openDirection="below"
                                                        @input="BadgeChange" />
                                        </CCol>
                                        
                                        <CCol md="12">
                                            <div class="custom-table-wrapper mt-2" style=" overflow: auto; overflow-y: hidden;">
                                                <table class='custom-table afb-blue'>
                                                    <thead>
                                                        <tr>
                                                            <th>{{this.getLanguage['MR']['T']}}</th>
                                                            <th>{{this.getLanguage['MR']['B']}} {{this.getLanguage['MR']['C']}}</th>
                                                            <th>{{this.getLanguage['MR']['TN']}}</th>
                                                            <th>{{this.getLanguage["PM"]["RS"]}}</th>
                                                            <th>{{this.getLanguage["MR"]["MOV"]}}</th>
                                                            <th>{{this.getLanguage['MR']['TF']}} ({{getLanguage["TNMT"]["PC"]}})</th>
                                                            <th>{{this.getLanguage['MR']['TT']}} ({{getLanguage["TNMT"]["PC"]}})</th>
                                                            <th class="tableCtnRight" v-for="(data,index) in arry_pointRate" v-if="bool_showPointTable"> {{getLanguage['MR']['TRON']}} ({{ data.CC }})</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(setup, index) in obj_memberRanking.MRSetting" :key="'setup' + index" v-if="defaultBadge.length > 0">
                                                            <td style="width:20px;">
                                                                {{ setup.R }}
                                                            </td>
                                                            <td style="width: 100px; height: 55px; ">
                                                                <div class="d-flex">
                                                                    <div class="text-center">
                                                                        <img :src="(defaultBadge[index].MRIURL)" class="img-fluid" :class="'badgeD'+(defaultBadge[index].BN)+'_'+index" :id="'img_'+index" /><br />
                                                                        <a href="javascript:void(0)" style="color:blue" @click="setPreview(index)">
                                                                            <u>{{getLanguage["GL"]["P"]}}</u>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td style="width: 150px;">
                                                                <div class="d-flex align-items-center" v-if="!setup.ERN">
                                                                    <i class="cil-color-border mr-2" @click="setup.ERN = true"></i>
                                                                    <CInput size="sm" :value="defaultBadge[index].MRIN" disabled />
                                                                </div>
                                                                <div class="d-flex align-items-center" v-if="setup.ERN">
                                                                    <i class="cil-save mr-2" @click="setup.ERN = false;setup.RN = ''"></i>
                                                                    <CInput size="sm" v-model="setup.RN" />
                                                                </div>
                                                            </td>
                                                            <td style="width:100px">
                                                                <span :style="`color:${setup.RS ? 'green':'red' }`" v-if="index<3 || (obj_memberRanking.I > 0 && ValidateStartDate(dateTS.startDate , minDate) && index <= int_oriSetCount-1)">
                                                                    {{ setup.RS ? getLanguage['GL']['ENB'] : getLanguage['GL']['DISB'] }}
                                                                </span>
                                                                <label class="switch" v-else>
                                                                    <input type="checkbox" :checked="setup.RS" @change="defaultThreshold($event, index)" :disabled="obj_memberRanking.I > 0 && ValidateStartDate(dateTS.startDate , minDate)&& index <= int_oriSetCount-1" />
                                                                    <span class="slider round"></span>
                                                                </label>
                                                            </td>
                                                            <td style="width:140px;">
                                                                <treeselect :multiple="false"
                                                                            :clearable="false"
                                                                            :options="dd_Validitye"
                                                                            :placeholder="getLanguage['MR']['MOV']"
                                                                            v-model="obj_memberRanking.MRSetting[index].V"
                                                                            ref="VLTY"
                                                                            :disabled="(index == 0  || !setup.RS) || (ValidateStartDate(dateTS.startDate , minDate)&& obj_memberRanking.I > 0)&& index <= int_oriSetCount-1"
                                                                            :openDirection=" index >=3 ?'above' : 'below'" />
                                                            </td>
                                                            <td style="width:180px;">
                                                                <CInput :prepend="getLanguage['TNMT']['PC']" v-if="index == 0" size="sm" :value="ThousandSeparator(0, getThousandCurrency ? 3 : 2)" disabled />
                                                                <CInput :prepend="getLanguage['TNMT']['PC']" v-else size="sm" :value="ThousandSeparator((((parseFloat(obj_memberRanking.MRSetting[index-1].TS) > 0) && (parseFloat(obj_memberRanking.MRSetting[index-1].TS) != 999999999) & (obj_memberRanking.MRSetting[index].RS)) ? parseFloat(obj_memberRanking.MRSetting[index-1].TS)+ 0.01 : 0), getThousandCurrency ? 3 : 2)" disabled />
                                                            </td>
                                                            <td style="width:180px;">
                                                                <CInput :prepend="getLanguage['TNMT']['PC']" size="sm" :value="ThousandSeparator(setup.TS, getThousandCurrency ? 3 : 2)" @change="v => setup.TS = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"
                                                                        :disabled="(!setup.RS ) && ValidateStartDate(dateTS.startDate , minDate)
                                                                         && ValidatePreviosEditable(index)" />
                                                                <span class="ErrMsg" style="font-weight: normal;">{{ ValidationMRSErrMsg('TS', 'PC', index) }}</span>
                                                            </td>
                                                            <td class="tableCtnRight" v-for="(data,index) in arry_pointRate" v-if="bool_showPointTable">
                                                                {{ThousandSeparator( (setup.TS * data.PR), CheckIsThousandCurrency(data.CC,this) ? 3 : 2)}}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div class="custom-table-wrapper">
                                                <br />
                                                <div>
                                                    <p class="font-weight-bold mb-0">
                                                        <template v-if="bool_showPointTable">
                                                            {{getLanguage["MR"]["CTU"]}}
                                                        </template>
                                                        <template v-else>
                                                            {{getLanguage["MR"]["CTST"]}}
                                                        </template>
                                                        <a href="javascript:void(0)" style="color:blue" @click="bool_showPointTable ? bool_showPointTable = false : bool_showPointTable = true"><u>{{getLanguage["MR"]["LPCT"]}}</u></a>
                                                    </p>
                                                </div>
                                                <table class='custom-table afb-blue' v-if="arry_pointRate.length > 0 && bool_showPointTable">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 25%;">{{getLanguage["BAL"]["C"]}}</th>
                                                            <th style="width: 25%;" class="tableCtnRight">{{getLanguage["BETRPT"]["AMT"]}}</th>
                                                            <th style="width: 25%;" class="tableCtnRight">{{getLanguage["TNMT"]["PC"]}} {{getLanguage["BAL"]["ER"]}}</th>
                                                            <th style="width: 25%;" class="tableCtnRight">{{getLanguage["TNMT"]["PC"]}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(data,index) in arry_pointRate">
                                                            <td>{{data.CC}}</td>
                                                            <td class="tableCtnRight">{{ThousandSeparator(data.PR, CheckIsThousandCurrency(data.CC,this) ? 3 : 2)}}</td>
                                                            <td class="tableCtnRight">{{ThousandSeparator(data.PR, CheckIsThousandCurrency(data.CC,this) ? 3 : 2)}}</td>
                                                            <td class="tableCtnRight">1</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </CCol>
                                    </CRow>
                                    <!--<div style="text-align:center;margin-top:20px" v-if="getUserInfo.AT==0 && obj_memberRanking.MRSetting.length < 10">
                                        <CButton color="outline-info" size="sm" @click="addTier()">
                                            <span class='plusIcon cil-plus'></span>
                                            add rank
                                        </CButton>
                                    </div>-->

                                    <div style="text-align:center;margin-top:20px">
                                        <CButton color="outline-info" size="sm" @click="saveMemberRanking()">
                                            <span class='plusIcon cil-plus'></span>
                                            {{ this.getLanguage["BTN"]["SV"] }}
                                        </CButton>
                                    </div>
                                    <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isRebate">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindowSA" style="width:30%">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MR"]["ARS"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeARSetting()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <table class='custom-table afb-blue'>
                                        <thead>
                                            <tr>
                                                <th style="width: 5%;">{{this.getLanguage['MR']['ACT']}}</th>
                                                <th style="width: 10%;">{{this.getLanguage['MR']['GC']}}</th>
                                                <th style="width: 5%;">{{this.getLanguage['TMPE']['default']}} %</th>
                                                <th style="width: 5%;">Add On %</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <label class="switch">
                                                        <input type="checkbox" />
                                                        <span class="slider round"></span>
                                                    </label>
                                                </td>
                                                <td>
                                                    SPORTBOOKS
                                                </td>
                                                <td>
                                                    0.05
                                                </td>
                                                <td>
                                                    <CInput type="text" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <label class="switch">
                                                        <input type="checkbox" />
                                                        <span class="slider round"></span>
                                                    </label>
                                                </td>
                                                <td>
                                                    LIVE CASINO
                                                </td>
                                                <td>
                                                    0.05
                                                </td>
                                                <td>
                                                    <CInput type="text" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <label class="switch">
                                                        <input type="checkbox" />
                                                        <span class="slider round"></span>
                                                    </label>
                                                </td>
                                                <td>
                                                    SLOTS
                                                </td>
                                                <td>
                                                    0.05
                                                </td>
                                                <td>
                                                    <CInput type="text" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <label class="switch">
                                                        <input type="checkbox" />
                                                        <span class="slider round"></span>
                                                    </label>
                                                </td>
                                                <td>
                                                    LOTTERY
                                                </td>
                                                <td>
                                                    0.05
                                                </td>
                                                <td>
                                                    <CInput type="text" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <label class="switch">
                                                        <input type="checkbox" />
                                                        <span class="slider round"></span>
                                                    </label>
                                                </td>
                                                <td>
                                                    FISHING
                                                </td>
                                                <td>
                                                    0.05
                                                </td>
                                                <td>
                                                    <CInput type="text" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <label class="switch">
                                                        <input type="checkbox" />
                                                        <span class="slider round"></span>
                                                    </label>
                                                </td>
                                                <td>
                                                    E CASINO
                                                </td>
                                                <td>
                                                    0.05
                                                </td>
                                                <td>
                                                    <CInput type="text" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <label class="switch">
                                                        <input type="checkbox" />
                                                        <span class="slider round"></span>
                                                    </label>
                                                </td>
                                                <td>
                                                    GAMES
                                                </td>
                                                <td>
                                                    0.05
                                                </td>
                                                <td>
                                                    <CInput type="text" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="modal-main-content">
                                    <div style="text-align:center;margin-top:20px">
                                        <CButton color="outline-info" size="sm" @click="saveMemberRanking()">
                                            <span class='plusIcon cil-plus'></span>
                                            {{ this.getLanguage["BTN"]["SV"] }}
                                        </CButton>
                                    </div>
                                    <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_fullPreview">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="width: 470px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["GL"]["P"]}}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd1">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content text-center">
                                    <div style="height: 234px; width: 410px; margin: auto; ">
                                        <div :class="'loyalD'+(defaultBadge[previewIndex].BN)+' card'+previewIndex" :style="'background:url('+defaultBadge[previewIndex].MRCURL+ ')'+ (defaultBadge[previewIndex].BN == 4 || defaultBadge[previewIndex].BN == 5 ||  defaultBadge[previewIndex].BN == 6? ', #000' : '')+';transform: scale(1.5); transform-origin: top left;;' ">
                                            <img :src="(defaultBadge[previewIndex].MRIURL)" class="img-fluid" :class="'badgeD'+(defaultBadge[previewIndex].BN)+'_'+previewIndex" />
                                            <p class="mb-0" :class="'cardnnoD'+(defaultBadge[previewIndex].BN)">1234 5678 1234 5678</p>
                                            <p class="mb-0" :class="'memberidD'+(defaultBadge[previewIndex].BN)">jackson</p>
                                            <div :class="'rankingNameD'+(defaultBadge[previewIndex].BN)">
                                                <p class="mb-0">{{ defaultBadge[previewIndex].MRIN }}</p>
                                                <div class="loyalprogram-progress-container" style=" height: 5px; width: 130px;">
                                                    <div class="loyalprogram-progress" :style="'height:5px;width: '+ (previewIndex == 4 ? '100%;' : '10%;')"></div>
                                                </div>
                                            </div>
                                            <p class="mb-0" :class="'cardnyearD'+(defaultBadge[previewIndex].BN)">{{ DateTime | moment("YYYY") }}</p>
                                        </div>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{getLanguage["SMB"]["LPS"]}}</h2>
                        <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="addMemberRankingSetting()"><span class='plusIcon cil-plus'></span>{{ this.getLanguage["BTN"]["AN"] }}</CButton>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <label class="searchLabel">{{this.getLanguage["AG"]["GN"]}} :</label>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroupfs"
                                                  :flat="true"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[1].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[1].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[1].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[1].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[1].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[1].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                         
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage["MR"]["LP"]}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["AG"]["G"]}}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["MR"]["PN"]}}<i @click="setSortTable('MRN')" :class="setSortLogo('MRN')" class="sortlogo"></i></th>
                                <th>{{getLanguage["LC"]["RS"]}}<i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i></th>
                                <th>{{ getLanguage["PM"]["PUB"] }} {{ getLanguage["AN"]["DT"] }}</th>
                                <th>
                                    <span class="grid-line">{{ this.getLanguage["GL"]["CT"] }} /</span>
                                    <span>{{ this.getLanguage["GL"]["UTS"] }}</span>
                                    <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                </th>
                                <th>{{this.getLanguage["GL"]["UB"]}}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["MR"]["AG"]}}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["MR"]["PN"]}}<i @click="setSortTable('MRN')" :class="setSortLogo('MRN')" class="sortlogo"></i></th>
                                <th>{{getLanguage["LC"]["RS"]}}<i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i></th>
                                <th>{{ getLanguage["PM"]["PUB"] }} {{ getLanguage["AN"]["DT"] }}</th>
                                <th>
                                    <span class="grid-line">{{ this.getLanguage["GL"]["CT"] }} /</span>
                                    <span>{{ this.getLanguage["GL"]["UTS"] }}</span>
                                    <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                </th>
                                <th>{{this.getLanguage["GL"]["UB"]}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_mrl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_mrl">
                            <td>{{ CountItem(index+1) }}</td>
                            <td v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">
                                <span id="actionBtnCol">
                                    <div class="custom-tooltip" v-if="checkModuleAccess('EDF', 'MS', constAccessType.delete)">
                                        <i class="cil-trash" @click="removeMemberRanking(data)"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.edit)">
                                        <i class="cil-color-border" @click="editMemberRanking(data.I)"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td>{{ data.GN }} ({{ data.PC }})</td>
                            <td>{{ data.MRN }}</td>
                            <td>
                                <span :style="`color:${data.RS == '2' ? 'green':'red' }`">
                                    {{ data.RS == '2' ? getLanguage['GL']['ENB'] : getLanguage['GL']['DISB'] }}
                                </span>
                            </td>
                            <td>
                                <span v-if="data.MRSD != '1900-01-01T00:00:00' && data.MRED != '1900-01-01T00:00:00'">
                                    <span class="grid-line">{{ formatDateTime(data.MRSD, "YYYY-MM-DD", "DD MMM YYYY") }}</span>
                                    <!--<span>{{ getLanguage["TNMT"]["T"] }} {{ formatDateTime(data.MRED, "YYYY-MM-DD", "DD MMM YYYY")  }}</span>-->
                                </span>
                                <span v-else>-</span>
                            </td>
                            <td>
                                <span class="grid-line">{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                                <span class="grid-line">{{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                            </td>
                            <td>{{ data.UB }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import DateRangePicker from 'vue2-daterange-picker'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import genericHelper from "@/modules/GenericHelper.js";
    import Loading from 'vue-loading-overlay';
    import { required, minLength, between, url, requiredIf } from 'vuelidate/lib/validators'
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import moment from "moment";
    import Vue from 'vue'
    import $ from 'jquery'
    import Editor from '@tinymce/tinymce-vue'

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading,
            DateRangePicker,
            'editor': Editor,
        },
        props: {

        },
        data() {
            return {
                bool_CV: false, // Check Validation
                bool_isAMV: false, // Add Modal Visible
                bool_isRebate: false,
                bool_fullLoading: false, // Add Modal Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TI: 0,//Total Items
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true,
                str_FV: [{ F: "AGI" }, { F: "CTS", FV: { startDate: "", endDate: "" } }], //Filter Value
                obj_memberRanking: {
                    I: 0,
                    RS: 2,
                    AGI: "",
                    AGIT: null,
                    MRN: "",
                    RD: { startDate: this.getTodayDate(), endDate: this.getTodayDate() },
                    MRSD: null,
                    MRED: null,
                    CI: null,
                    PCT: null,
                    BSET: 1,
                    MRSetting: [],
                    tncModels:[]
                    //MRGameSetting: []
                },
                int_oriSetCount:0,
                //obj_rankingSetting: {
                //    I: 0,
                //    MRI: 0,
                //    R: 0,
                //    RN: null,
                //    TSF: 0,
                //    TST: 0,
                //    MRIURL: null,
                //    ISI: 1,
                //    CC: ""
                //},
                obj_Post: {
                    SelectedBrands: []
                },
                minDate: this.getTodayDate(),
                memberRankingEndDate: this.getTodayDate(),
                selectedLang: "en",
                selectedFile: null,
                init: {
                    height: 450,
                    plugins: [
                        'lists advlist',
                        'image imagetools',
                        'link autolink',
                        'table',
                        'charmap',
                        'searchreplace visualblocks code fullscreen',
                        'print preview anchor insertdatetime',
                        'help codesample hr pagebreak nonbreaking toc textpattern noneditable',
                        'importcss',
                        'directionality',
                        'visualchars',
                        'emoticons',
                        'autosave',
                        'wordcount'
                    ],
                    toolbar:
                        'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
                    branding: false,
                    menubar: true,
                    file_picker_callback: function (cb) {
                        var input = document.createElement('input');
                        input.setAttribute('type', 'file');
                        input.setAttribute('accept', 'image/*');

                        input.onchange = function () {
                            this.bool_fullLoading = true;
                            var file = this.files[0];
                            var reader = new FileReader();

                            if (!file) {
                                return;
                            }
                            if (!file.name.match(/\.(jpg|jpeg|png)$/)) {
                                return;
                            }

                            reader.onload = function () {
                                var that = this;
                                var formData = new FormData();
                                formData.append('image', file)

                                Axios({
                                    url: 'https://api.imgur.com/3/image',
                                    method: 'POST',
                                    headers: {
                                        'Authorization': 'Client-ID ' + constImgURClientId
                                    },
                                    data: formData
                                })
                                    .then((result) => {
                                        let url = result.data.data.link;
                                        that.bool_fullLoading = true;
                                        cb(url, { title: file.name });
                                    })
                                    .catch((err) => {
                                        that.bool_fullLoading = true;
                                        console.log(err);
                                    });
                            };
                            reader.readAsDataURL(file);
                        };
                        input.click();
                    }
                },
                arry_mrl: [],
                dateTS: {
                    startDate: this.getTodayDate(),
                    endDate: this.getTodayEndDate()
                },
                array_mrtnc: [],
                array_mrn: [],
                constAccessType: constAccessType,
                visible: false,
                dd_agentgroup: [],//agent group option
                dd_agentgroupfs: [],//agent group option
                dd_language: [],
                dd_bl: [],
                dd_cl: [],
                dd_CategoryList:[],
                dd_currency: [],
                arry_pointRate:[],
                defaultBadge: [],
                dd_MRPointCalculationType: [],
                //dd_MRPointCalculationType: [{ id: 1, label: "Total Turnover" }],
                //dd_Validitye:[{ id: "6", label: "6 Month" },{ id: "12", label: "12 Month" },{ id: "0", label: "Permanent" }],
                dd_Validitye: [],
                searchAgi: null,
                ISOCode: "",
                CurrencyId: 0,
                DateTime: this.getTodayDate(),
                previewIndex: 0,
                bool_fullPreview: false,
                bool_showPointTable: true,

                regexDecimal: new RegExp("^[0-9]+[\.]?[0-9]*$")
            }
        },
        validations: {
            obj_memberRanking: {
                AGIT: { required },
                MRN: { required },
                PCT: { required },
                MRSetting:{
                    $each: {
                        TS: {
                            decimal: (function (value, obj) {
                                return this.regexDecimal.test(value);

                            })
                        }
                }
                }
               
            },
        },
        created() {
            if (this.$route.path == '/MS/LPS') {
                this.$parent.showSubMenu = 'MS';
                this.$parent.showActiveMenu = 'MS.LPS';
            } else if (this.$route.path == '/AFF/LPS') {
                this.$parent.showSubMenu = 'AFF';
                this.$parent.showActiveMenu = 'AFF.LPS';
            }
            this.setThousandCurrency(false);
            this.getAgentGroup();
            this.getMRList();
            this.getDropdownList();
            this.getMRPointCalculationType();
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency'])
        },
        methods: {
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            CurrencyChange(value) {
                this.setThousandCurrency(this.CheckIsThousandCurrency(value, this), this);
            },
            checkThousandCurrency() {
                var that = this;

                this.getDataApi(`/api/memrank/currency/${that.CurrencyId}`,
                    function (d, s) {
                        if (s && d) {
                            that.CurrencyChange(d.CS);
                        }
                    });

            },
            ValidateStartDate(start,today){
                const startDate = new Date(start);
                const todayDate = new Date(today);
                

                return todayDate > startDate  ; //if ture means already start
            },
            ValidatePreviosEditable(index){
                if (this.obj_memberRanking.MRSetting.length > this.int_oriSetCount && index == this.int_oriSetCount - 1) {
                return false;
                }
                // 如果index大于或等于int_oriSetCount，允许编辑
                if (index >= this.int_oriSetCount) {
                    return false;
                }
                // 否则不允许编辑
                return true;
            },
            DateTimeChange(type, event) {
                if (type == "RD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.dateTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.dateTS.startDate = this.getTodayDate();
                        this.MemberRankingStartDateChange(this.dateTS.startDate);
                    }
                }
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[1].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[1].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[1].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[1].FV.endDate = "";
                    }
                }
            },
            MemberRankingDateRangePickerUpdateEvent(dt) {
                if (dt) {
                    if (dt.startDate) {
                        dt.startDate.setHours(0, 0, 0, 0);
                    }

                    if (dt.endDate) {
                        const year = new Date().getFullYear();
                        dt.endDate.setFullYear(year, 11, 31);
                        dt.endDate.setHours(23, 59, 59, 59, 997);
                    }
                }
                this.dateTS.startDate = dt.startDate;
                this.dateTS.endDate = dt.endDate;
                this.MemberRankingStartDateChange(this.dateTS.startDate)
            },
            MemberRankingStartDateChange(memberRankingStartDate) {
                if ((moment(memberRankingStartDate).year() > moment(this.memberRankingEndDate).year()) || moment(memberRankingStartDate).year() < moment(this.memberRankingEndDate).year()) {
                    this.memberRankingEndDate = moment(memberRankingStartDate).set({ month: 11, date: 31, hour: 23, minute: 59, second: 59, millisecond: 997 });

                } else {
                    const currentYear = new Date().getFullYear();
                    const endOfYear = new Date(currentYear, 11, 31, 23, 59, 59, 997);
                    this.memberRankingEndDate = endOfYear;
                    this.dateTS.endDate = this.memberRankingEndDate;
                }
                return moment(this.memberRankingEndDate, 'DD MMM YYYY HH:mm:ss').toString();;
            },
            DisplayMemberRankingEndDate(memberRankingEndDate, isToString = false) {

                if (isToString) {
                    return moment(memberRankingEndDate).subtract('seconds', 1).format("YYYY-MM-DD HH:mm:ss");
                }

                return moment(memberRankingEndDate).subtract('seconds', 1);
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('LPS', 'MS', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
                this.dd_language = [];
            },
            addMemberRankingSetting() {
                this.obj_memberRanking = {
                    I: 0,
                    RS: 2,
                    AGI: "",
                    AGIT: null,
                    MRN: null,
                    //RD: { startDate: this.getTodayDate(), endDate: this.getTodayDate() },
                    MRSD: null,
                    MRED: null,
                    CI: 0,
                    PCT: null,
                    BL: 1,
                    MRSetting: [],
                    tncModels:[]
                    //MRGameSetting:[]
                };
                this.dateTS.startDate = this.getTodayDate();
                this.dateTS.endDate = this.getTodayEndDate();

                const currentYear = new Date().getFullYear();
                const endOfYear = new Date(currentYear, 11, 31, 23, 59, 59, 997); // 11 表示 12 月份
                this.memberRankingEndDate = endOfYear;
                this.array_mrtnc = [];
                this.array_mrn = [];
                this.arry_pointRate=[],
                this.obj_Post.SelectedBrands = [];
                this.visible = false;
                this.LoopTierSetup();
                this.BadgeChange();
                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && this.dd_agentgroup.length < 2) {
                        this.obj_memberRanking.AGIT = this.dd_agentgroup[0].id;
                    }
                }
                this.bool_isAMV = true;
                this.bool_CV = false;
            },
            EditLoopTierSetup() {
                let currentSettings = this.$data.obj_memberRanking.MRSetting;
                const maxTierCount = 10;

                // 计算当前设置的数量
                let currentCount = currentSettings.length;

                // 计算需要添加的数量
                let needToAddCount = maxTierCount - currentCount;

                // 如果当前设置已经达到最大数量，则无需添加
                if (needToAddCount <= 0) {
                    return;
                }

                // 循环添加新的记录直到达到最大数量
                for (let i = 0; i < needToAddCount; i++) {
                    let newTier = {
                        R: currentSettings.length + 1,  // 更新R的值为新的索引
                        RS: false,  
                        TS: 0,      
                        RN: "",
                        ERN: false,
                        MWL: 0,
                        V: 3        
                    };

                    // 将新Tier添加到数组末尾
                    currentSettings.push(newTier);
                }

                // 更新obj_memberRanking的MRSetting
                this.$set(this.$data.obj_memberRanking, 'MRSetting', currentSettings);
            },

            LoopTierSetup() {
                //var tier = ['Amber', 'Topaz', 'Sapphire', 'Emerald', 'Diamond'];

                var MRSetting = [];
                for (var i = 0; i < 10; i++) {
                    MRSetting[i] = {
                        R: i + 1,
                        RS: (i < 3) ? true : false,
                        TS: (i == 2) ? 999999999 : 0,
                        RN: "",
                        ERN: false,
                        MWL:0,
                        V:i==0?0:3
                    };
                }
                this.$set(this.$data.obj_memberRanking, 'MRSetting', MRSetting);
                
                var ddCat = [];
                var self = this; // 保存当前上下文

                // this.getDataApi(`/api/dd/gameCat/0`,
                //     function (d, s) {
                //         if (s && d && d.dropdownlist) {
                //             ddCat = d.dropdownlist;
                //             ddCat.unshift({ id: "0", label: self.getLanguage['GL']['ALL'] });
                //             var MRGameSetting = [];

                //             for (var i = 0; i < ddCat.length; i++) {
                //                 MRGameSetting[i] = {
                //                     CatId: ddCat[i].Id,
                //                     str_category: ddCat[i].label,
                //                     RS: 1,
                //                     CRatio:"5.00%",
                //                     T1: 0.05,
                //                     T2: 0.08,
                //                     T3: 0.10,
                //                     T4: 0.12,
                //                     T5: 0.15,
                //                 };
                //             }

                //             self.$set(self.$data.obj_memberRanking, 'MRGameSetting', MRGameSetting);
                //         } else {
                //             ddCat = [];
                //         }
                // });

            },
            defaultThreshold(e, index) {
                if (index >= 3) {
                    if (this.obj_memberRanking.MRSetting[index - 1].RS) {
                        e.target.checked = (e.target.checked) ? e.target.checked = false : e.target.checked = true;
                        this.obj_memberRanking.MRSetting[index].RS = (this.obj_memberRanking.MRSetting[index].RS) ? this.obj_memberRanking.MRSetting[index].RS = false : this.obj_memberRanking.MRSetting[index].RS = true;
                        if (this.obj_memberRanking.MRSetting[index].TS == 0 && this.obj_memberRanking.MRSetting[index].RS) {
                            this.obj_memberRanking.MRSetting[index].TS = 999999999;
                            this.obj_memberRanking.MRSetting[index - 1].TS = 0;
                        } else if (!this.obj_memberRanking.MRSetting[index].RS) {
                            this.obj_memberRanking.MRSetting[index].TS = 0;
                            this.obj_memberRanking.MRSetting[index -1].TS = 999999999;
                        }
                    } else {
                        e.target.checked = false;
                    }
                } else {
                    e.target.checked = true;
                }
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getMRList();
                }
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroupfs.length > 0) {
                                that.dd_agentgroupfs.forEach(that.disableAgentGroupParent);
                            }

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            getCurrencyList(agi) {
                var that = this;
               
                this.getDataApi(`/api/memrank/grate/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.arry_pointRate = d;
                            //if (that.arry_pointRate.length === 1) {
                            //    that.ISOCode = that.arry_pointRate[0].CC;
                            //    that.CurrencyId = that.arry_pointRate[0].CI;
                            //} else {
                            //    that.ISOCode = this.getLanguage["TNMT"]["PC"];
                            //    that.CurrencyId = 8;
                            //}
                        }
                    });
            },
            getMRList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                temp_ += this.str_FV[i].FV[x];
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'CTS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                path += "&f[CTS_from]=" + cts_from;
                            }
                            if (this.str_FV[i].FV.endDate != "") {
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);
                                path += "&f[CTS_to]=" + cts_to;
                            }
                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                //path += ("&f[RS]=2");

                this.getDataApi(`/api/memrank/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setMRList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            BadgeChange(id) {
                this.bool_fullLoading = true;
                this.bool_fullScreen = true;
                if (id == undefined || id == null) {
                    id = 1;
                }
                this.obj_memberRanking.BSET = id;
                this.selectedFile = [null, null, null, null, null];
                var that = this;
                that.getDataApi(`/api/dd/lpbl/` + id,
                    function (d, s) {
                        if (s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            that.defaultBadge = d;
                        }
                    });
            },
            onFileSelected(index, event) {
                var image = this.validateFile(event);
                this.selectedFile[index] = image;
                if (image) {
                    document.getElementById('img_' + index).src = URL.createObjectURL(image);
                }
            },
            validateFile(event, maxFileSize = 1, validFileExtension = [".jpg", ".jpeg", ".bmp", ".gif", ".png", ".webp"]) {
                var file = null;
                this.newImg = true;
                var files = event.target.files;
                if (files && files.length > 0) {
                    var filesize = ((files[0].size / 1024) / 1024).toFixed(4); // MB

                    if (filesize <= maxFileSize) {
                        var validDimension = true;
                        var _URL = window.URL || window.webkitURL;
                        var img = new Image();
                        var that = this;
                        img.src = _URL.createObjectURL(files[0]);
                        img.onload = function () {
                            if (this.width > 100 || this.height > 100) {
                                that.showErrorMessage(that.utilGetErrorLanguage("ERR.TI"), that.utilGetErrorLanguage("ERR.UFD"));
                                event.target.value = '';
                                that.newImg = false;
                                validDimension = false;
                            }
                        };
                        if (validDimension) {
                            var blnValid = false;
                            for (var j = 0; j < validFileExtension.length; j++) {
                                var sCurExtension = validFileExtension[j];
                                if (files[0].name.substr(files[0].name.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                                    blnValid = true;
                                    break;
                                }
                            }

                            files[0].name.substr(files[0].name.length - sCurExtension.length, sCurExtension.length)
                            var fileName = files[0].name.substr(0, files[0].name.length - sCurExtension.length).trim();
                            fileName = fileName.replace(/[^a-zA-Z0-9-_\s]/g, '');
                            if (fileName != files[0].name.substr(0, files[0].name.length - sCurExtension.length)) {
                                this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage("ERR.4030")));
                                event.target.value = '';
                                this.newImg = false;
                            } else if (blnValid) {
                                file = files[0];
                            } else {
                                this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage("ERR.4020"), files[0].name) + validFileExtension.join(", "));
                                event.target.value = '';
                                this.newImg = false;
                            }
                        }
                    } else {
                        // Outlet deposit in module 3.1, upload receipt limited size 200KB
                        if (maxFileSize == 0.2) {
                            this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), this.utilGetErrorLanguage("ERR.4040"));
                            event.target.value = '';
                            this.newImg = false;
                        } else {
                            this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), this.utilGetErrorLanguage("ERR.4010"));
                            event.target.value = '';
                            this.newImg = false;
                        }

                    }
                }

                return file;
            },
            setMRList(data) {
                this.arry_mrl = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
            },
            setMT(data) {
                this.obj_memberRanking = data;
                this.int_oriSetCount = data.MRSetting.filter(item => item.RS == true).length;
                this.EditLoopTierSetup();
                // this.int_oriSetCount = data.MRSetting.length;
                if(this.obj_memberRanking.tncModels==null){
                    this.obj_memberRanking.tncModels=[];
                }
                
                this.BadgeChange(data.BSET);
                this.getCurrencyList(data.AGI)
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            AgentGroupChangefs(value) {
                if (value != "") {
                    this.str_FV[0].FV = value.split("-")[1];
                }
                else {
                    this.str_FV[0].FV = null;
                }
            },
            AgentGroupChange(value) {
                var agi = [];
                
                if (value && value.length > 0) {

                    if (value.split("-")[0] == 3) {
                        agi.push(value.split("-")[1]);
                    }

                    if (agi.length > 0) {  
                        var that = this;

                        this.obj_Post.SelectedBrands = agi;
                        this.bool_fullLoading = true;
                        this.postDataApi(`/api/dd/langbyaglist`, this.obj_Post,
                            function (d, s) {
                                if (s) {
                                    that.dd_language = d.dropdownlist;
                                    that.dd_language.forEach(item => {
                                        if (!that.obj_memberRanking.tncModels.some(model => model.language === item.id)) {
                                            that.obj_memberRanking.tncModels.push({
                                                language: item.id,
                                                label: item.label,
                                                tnc_content: '', // 初始值，你可以根据需要设置
                                                program_name: '', // 初始值，你可以根据需要设置
                                            });
                                        }
                                    });
                                    that.bool_fullLoading = false;
                                    if (that.dd_language.length > 0) {
                                        that.selectedLang = that.dd_language[0].id;
                                    }
                                }
                            });
                        var agi = agi[0];
                        this.getCurrencyList(agi);
                    }
                    else {
                        this.dd_language = [];
                    }
                }
                else {
                    this.obj_Post.SelectedBrands = [];
                    this.dd_agentgroup.forEach(this.LoopAgentGroupParent);

                    if (this.obj_Post.SelectedBrands.length > 0) {
                        var that = this;

                        this.postDataApi(`/api/dd/langbyaglist`, this.obj_Post,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.dd_language = d.dropdownlist;
                                    that.dd_language.forEach(item => {
                                        if (!that.obj_memberRanking.tncModels.some(model => model.language === item.id)) {
                                            that.obj_memberRanking.tncModels.push({
                                                language: item.id,
                                                label: item.label,
                                                tnc_content: '', // 初始值，你可以根据需要设置
                                                program_name: '', // 初始值，你可以根据需要设置
                                            });
                                        }
                                    });

                                    if (that.dd_language.length > 0) {
                                        that.selectedLang = that.dd_language[0].id;
                                    }
                                }
                            });
                    }
                    else {
                        this.dd_language = [];
                    }
                }
               
            },
            LoopAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] == "3") {
                    this.obj_Post.SelectedBrands.push(agi[1]);
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.LoopAgentGroupParent);
                }
            },
            HTMLEditorTextChange(value, index) {
                this.obj_memberRanking.tncModels[index].tnc_content = value.level.content;
            },
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {

                    var validateObjMR = this.$v.obj_memberRanking[value];
                    //var validateObjRS = this.$v.obj_rankingSetting[value];

                    //if (validateObjMR.required != undefined && !validateObjMR.required) {
                    //    return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MT"][langKey]);
                    //}

                    if (validateObjMR.required != undefined && !validateObjMR.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MR"][langKey]);
                    }
                }

              

            },
            ValidationMRSErrMsg(value, langKey = "", index ) {
                
                    if (this.bool_CV) {
                        // var errObj = this.$v.settingList.$each.$iter[index].SV;
                    var validateObj = this.$v.obj_memberRanking.MRSetting.$each.$iter[index].TS;

                    if (validateObj != null) {
                        // if (validateObj.required != undefined && !validateObj.required) {
                        //     return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["TNMT"][langKey]);
                        // }
                        // else if (validateObj.alphaNum != undefined && !validateObj.alphaNum) {
                        //     return String.format(this.utilGetErrorLanguage('1008'), this.getLanguage["TNMT"][langKey]);
                        // }
                        // else if (validateObj.numeric != undefined && !validateObj.numeric) {
                        //     return String.format(this.utilGetErrorLanguage('1009'), this.getLanguage["TNMT"][langKey]);
                        // }
                        // else if (validateObj.between != undefined && !validateObj.between) {
                        //     return String.format(this.utilGetErrorLanguage('1004'), this.getLanguage["TNMT"][langKey]);
                        // }
                        // else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        //     return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["TNMT"][langKey]);
                        // }
                        // else if (validateObj.minValueValue != undefined && !validateObj.minValueValue) {
                        //     return String.format(this.utilGetErrorLanguage('4442'), this.getLanguage["TNMT"][langKey]);
                        // }
                        if (validateObj.decimal != undefined && !validateObj.decimal) {
                            return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["TNMT"][langKey]);
                        }
                    }
                

                }
                
            },
            editAutoRebate() {
                this.bool_isRebate = true;
            },
            closeARSetting() {
                this.bool_isRebate = !this.bool_isRebate;
            },
            saveMemberRanking() {
                this.bool_CV = true;
                this.bool_fullLoading = true;
                this.bool_fullScreen = true;
                //this.obj_memberRanking['RS'] = 2;

                //for (var d of this.dd_mt) {
                //    if (d.id == this.obj_memberRanking['MRN']) {
                //        this.obj_memberRanking['RN'] = d.label;
                //    }
                //}

                //if (this.obj_memberRanking['RN'] == 'Custom') {
                //    this.obj_memberRanking['RN'] = this.obj_memberRanking['CMRN'];
                //}

                if (this.obj_memberRanking.AGIT != null && this.obj_memberRanking.AGIT.length > 0) {
                    var agi = this.obj_memberRanking.AGIT.split("-");
                    this.obj_memberRanking.AGI = agi[1];
                }

                var str_holdSTR = this.obj_memberRanking['RN']
                if (this.obj_memberRanking.CNN == null || this.obj_memberRanking.CNN == "") {
                    this.obj_memberRanking['CNN'] = str_holdSTR
                }
                if (this.obj_memberRanking.KHN == null || this.obj_memberRanking.KHN == "") {
                    this.obj_memberRanking['KHN'] = str_holdSTR
                }
                if (this.obj_memberRanking.IDN == null || this.obj_memberRanking.IDN == "") {
                    this.obj_memberRanking['IDN'] = str_holdSTR
                }
                if (this.obj_memberRanking.KRN == null || this.obj_memberRanking.KRN == "") {
                    this.obj_memberRanking['KRN'] = str_holdSTR
                }
                if (this.obj_memberRanking.MYN == null || this.obj_memberRanking.MYN == "") {
                    this.obj_memberRanking['MYN'] = str_holdSTR
                }
                if (this.obj_memberRanking.THN == null || this.obj_memberRanking.THN == "") {
                    this.obj_memberRanking['THN'] = str_holdSTR
                }
                if (this.obj_memberRanking.VNN == null || this.obj_memberRanking.VNN == "") {
                    this.obj_memberRanking['VNN'] = str_holdSTR
                }
                if (this.obj_memberRanking.ION == null || this.obj_memberRanking.ION == "") {
                    this.obj_memberRanking['ION'] = str_holdSTR
                }
                this.obj_memberRanking["MRSD"] = this.parseDateToJsonString(this.dateTS.startDate);

                this.$v.obj_memberRanking.$touch();
                setTimeout(() => {
                    $(".ErrMsg").each(function (index) {
                        if ($(this).text()) {
                            $('.popupWindowSA .modal-main-content').animate({
                                scrollTop: $(this).parent().offset().top - 70
                            }, 'slow');
                            return false;
                        }
                    });
                }, 100)

                if (!this.$v.obj_memberRanking.$error) {
                    var that = this;

                    this.postDataApi(`/api/memrank/s`, this.obj_memberRanking,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.getMRList();
                            }
                        });
                } else {
                    this.bool_fullLoading = false;
                    //find out the unfilled and required inputm then focus it.
                    const validation = this.$v["obj_memberRanking"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            editMemberRanking(id) {
                this.bool_fullLoading = true;
                this.bool_CV = false;
                var that = this;
                this.getDataApi(`/api/memrank/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setMT(d.D);
                            that.bool_isAMV = false;
                            if (that.obj_memberRanking.AGI != 0) {
                                that.obj_memberRanking.AGIT = "3-" + that.obj_memberRanking.AGI;
                                that.AgentGroupChange(that.obj_memberRanking.AGIT);
                            }
                            //for (var d of that.dd_mt) {
                            //    if (d.label == that.obj_memberRanking['RN']) {
                            //        that.obj_memberRanking['MRN'] = d.id;
                            //    }
                            //}
                            that.dateTS.startDate = that.obj_memberRanking.MRSD;
                            that.bool_isAMV = true;
                        }
                    });
            },
            removeMemberRanking(data) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: data.I,
                            uts: data.UTS
                        };

                        this.postDataApi(`/api/memrank/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getMRList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            // loadGameCategoryOptions({ action, callback, instanceId }) {
            //     var that = this;
            //     this.getDataApi(`/api/dd/gameCat`,
            //         function (d, s) {
            //             if (s && d && d.dropdownlist) {
            //                 that.ddGameCategoryList = d.dropdownlist;
            //             }
            //             else {
            //                 that.ddGameCategoryList = null;
            //             }
            //             callback();
            //         });
            // },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getMRList();
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getMRList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            clearDateRangeFilter() {
                this.str_FV[1].FV = {
                    startDate: "",
                    endDate: ""
                };
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            setPreview(index) {
                this.previewIndex = index;
                this.bool_fullPreview = true;
            },
            closeAdd1() {
                this.previewUrl = null;
                this.bool_fullPreview = !this.bool_fullPreview;
            },
            getDropdownList() {
                this.dd_Validitye = [{ id: "3", label: "3 " + this.getLanguage['DB']['MT'] }, { id: "6", label: "6 " + this.getLanguage['DB']['MT'] }, { id: "12", label: "12 " + this.getLanguage['DB']['MT'] }, { id: "0", label: this.getLanguage['MR']['PM'] }];
                this.dd_bl = [{ id: '1', label: this.getLanguage['MR']['DDTLC'] }, { id: '2', label: this.getLanguage['MR']['DDTCD1'] }, { id: '3', label: this.getLanguage['MR']['DDTCD2'] }, { id: '4', label: this.getLanguage['MR']['DDTPB'] }, { id: '5', label: this.getLanguage['MR']['DDTCB'] }, { id: '6', label: this.getLanguage['MR']['DDTGS'] }];
            },
            getMRPointCalculationType() {
                this.dd_MRPointCalculationType = [{ id: "1", label: this.getLanguage['MEM']['CWTO'] }];
            }
            
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getMRList();
                this.getDropdownList();
            },
        },
    }
</script>

<style scoped>
    .pcDaterange .reportrange-text {
        display: block;
        padding: 0 !important;
        margin-top: -1px;
    }

    .mrLanguage {
        flex-wrap: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
    }

    .mrLanguageLabel {
        min-width: max-content;
        padding: 0.5rem 0.5rem;
        font-size: smaller;
        border-width: 0px;
    }
    /* width */
    .mrLanguage::-webkit-scrollbar {
        height: 5px;
    }
    /* Track */
    .mrLanguage::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
    /* Handle */
    .mrLanguage::-webkit-scrollbar-thumb {
        background: #888;
    }
    /* Handle on hover */
    .mrLanguage::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    .flagClass {
        height: 20px;
        width: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Marketing/MemberRankingSetting.vue